export const loginAPI = "/login";
export const logoutAPI = "/logout";
export const profileAPI = "/profile";
export const changePasswordAPI = "/change-password";
